import React from 'react';
import InterventionsManage from '../InterventionsManage';

const PanelInterventionsManageEmbedV1: React.FC = () => <InterventionsManage embedded />;

export default PanelInterventionsManageEmbedV1;
